import { createSlice } from '@reduxjs/toolkit';
import * as CanvasOps from './ops';
import { actions as DocumentActions } from '../document';
import { CANVAS_SIZE, DEFAULT_ZOOM_LEVEL } from './consts';

// default state of the canvas
const canvasSlice = createSlice({
  name: 'canvas',
  initialState: {
    fileInfo: null,
    instructionsBox: {
      position: { x: 800, y: 100 },
      expanded: false,
    },
    labelFocus: false,
    defaultEditMode: null, // this is the editMode that is applied when a doc is loaded
    defaultModelType: '',
    labelBankExpanded: false,
    showKeyboardShortcuts: false,
    keyboardShortcutsPosition: { x: 200, y: 100 },
    compareWithSolution: false,
    hintsAreApplicable: false,
    showHints: false,
    viewportSize: { x: 0, y: 0 },
    zoomLevel: DEFAULT_ZOOM_LEVEL,
    canZoomIn: true,
    canZoomOut: true,
    scale: 1.0,
    offset: { x: 0, y: 0 },
    selection: {
      type: null,
      label: null,
      latched: false,
      latchData: {},
      from: null,
      to: null,
    },
  },
  reducers: {
    // create an action/reducer pair for each of the CanvasOps
    ...Object.keys(CanvasOps).reduce((obj, key) => {
      obj[key] = (state, { payload }) => {
        CanvasOps[key](state, payload);
      };
      return obj;
    }, {}),
  },
  extraReducers: {
    [DocumentActions.modelLoaded]: (state, { payload }) => {
      state.fileInfo = payload.fileInfo;
      CanvasOps.setSelection(state, { latched: false });
      state.instructionsBox.position = {
        x: (state.viewportSize.x || 1020) - 420,
        y: 160,
      };
      state.keyboardShortcutsPosition = {
        x: (state.viewportSize.x || 1020) - 700,
        y: 50,
      };
      state.instructionsBox.expanded = true;
      state.zoomLevel = DEFAULT_ZOOM_LEVEL;
      state.offset = {
        x: Math.max(0, Math.floor((CANVAS_SIZE - state.viewportSize.x) / 2)),
        y: Math.max(0, Math.floor((CANVAS_SIZE - state.viewportSize.y) / 2)),
      };
      const editMode = payload.doc?.editMode;
      if (editMode === 'solution') {
        state.labelBankExpanded = false;
      } else {
        state.labelBankExpanded = true;
      }
      const mode = payload.doc?.mode;
      const hintsAreapplicable = editMode !== 'solution' && mode !== 'creation';
      if (hintsAreapplicable) {
        state.hintsAreApplicable = true;
        state.showHints = true;
      } else {
        //re-initialize states in case of closing reference mode then opening solution mode
        state.hintsAreApplicable = false;
        state.showHints = false;
      }
    },
    [DocumentActions.placeLabel]: (state, { payload }) => {
      CanvasOps.setSelection(state, { latched: false });
    },
    [DocumentActions.deleteNode]: (state, { payload }) => {
      CanvasOps.setSelection(state, { latched: false });
    },
    [DocumentActions.deleteSignal]: (state, { payload }) => {
      CanvasOps.setSelection(state, { latched: false });
    },
    '@@redux-undo/UNDO': state => {
      CanvasOps.setSelection(state, { latched: false });
    },
    '@@redux-undo/REDO': state => {
      CanvasOps.setSelection(state, { latched: false });
    },
    'saveLoad/fileSaved': (state, { payload }) => {
      if (payload.source) {
        state.fileInfo = payload;
      }
    },
  },
});

export default canvasSlice;
